class ProductQuickView extends HTMLElement {
    constructor() {
        super();

        this.quickViewButton = this.querySelector('.product-quick-view-button');
        this.quickViewDialog = this.querySelector('dialog');
        this.quickViewCloseButton = this.querySelector('.product-quick-view-close-button');
        this.quickViewContent = this.querySelector('.product-quick-view-content');

        this.closestAnchor = this.closest('a');

        if (!this.dataset.handle) {
            console.error('Product handle not provided in product-quick-view', this);
            return;
        }

        this.initListeners();
        this.initDialogStateObserver();
    }

    initListeners() {
        this.quickViewButton.addEventListener('click', this.openQuickView.bind(this));
        this.quickViewCloseButton.addEventListener('click', this.closeQuickView.bind(this));

        this.parentElement.parentElement.appendChild(this);
    }

    async openQuickView(e) {

        e.preventDefault();

        let existingContent = this.quickViewContent.innerHTML;

        if (!existingContent) {
            this.quickViewButton.classList.add('loading-spinner');

            try {
                let productResponse = await fetch(`/products/${this.dataset.handle}`),
                    productHtml = await productResponse.text();

                let domParser = new DOMParser(),
                    productDocument = domParser.parseFromString(productHtml, 'text/html'),
                    productSection = productDocument.querySelector('product-section'),
                    productLeftColumnBlocks = productSection.querySelector('.product-left-column-blocks'),
                    productCarouselThumbnails = productSection.querySelector('.carousel__thumbnails'),
                    productBlocks = productSection.querySelectorAll('.product__block'),
                    mattressUpsell = productDocument.querySelector('.mattress-upsell'),
                    headboardUpsell = productDocument.querySelector('.headboard-upsell');


                if (productSection) {
                    productLeftColumnBlocks?.remove();
                    productCarouselThumbnails?.remove();
                    mattressUpsell?.remove();
                    headboardUpsell?.remove();

                    productBlocks.forEach((block) => {
                        if (!block.classList.contains('product__block--product_title') && !block.classList.contains('product__block--product_price') && !block.classList.contains('product__block--product_form')) {
                            block.remove();
                        }
                    });

                    let productWrapper = productSection.querySelector('.product-wrapper');

                    productSection.innerHTML = '';

                    productSection.appendChild(productWrapper);

                    productSection.appendChild(productWrapper);


                    this.quickViewContent.appendChild(productSection);
                } else {
                    console.error('Product section not found', this);
                }

                this.quickViewButton.classList.remove('loading-spinner');

                document.body.classList.add('pv-fetched');
            } catch (error) {
                console.error(`Error fetching product: ${this.dataset.handle}`, error);
                this.quickViewButton.classList.remove('loading-spinner');
            }
        }



        this.quickViewDialog.showModal();

    }

    closeQuickView(e) {
        e.preventDefault();
        this.quickViewDialog.close();
    }

    initDialogStateObserver() {
        if (!this.quickViewDialog) return;

        let pendingUpdate = false;

        const syncBodyClass = () => {
            pendingUpdate = false;
            if (this.quickViewDialog.hasAttribute('open')) {
                document.body.classList.add('dialog-open');
            } else {
                document.body.classList.remove('dialog-open');
            }
        };

        const observer = new MutationObserver((mutations) => {
            const hasOpenChange = mutations.some(
                (mutation) => mutation.type === 'attributes' && mutation.attributeName === 'open'
            );

            if (hasOpenChange && !pendingUpdate) {
                pendingUpdate = true;
                requestAnimationFrame(syncBodyClass);
            }
        });

        observer.observe(this.quickViewDialog, {
            attributes: true,
            attributeFilter: ['open']
        });

        // Initial state check
        if (this.quickViewDialog.hasAttribute('open')) {
            requestAnimationFrame(syncBodyClass);
        }
    }
}

customElements.define('product-quick-view', ProductQuickView);